<template>
  <div class="columns">
    <div class="column has-text-centered" v-for="fan in fans" :key="fan.io">
      <p class="subtitle">{{fan.title}}: {{fan.io}}</p>
      <img :src="$parent.baseurl +  'static/icons/fan_' + (fan.state == 'running' ? 'on' : 'off') + '.png'"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fans: []
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "fan.php")
        .then(response => {
          this.fans = response.data;

          setTimeout(() => {
            this.startMonitor();
          }, 30000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorFan.vue